import { IMemberDetailsState } from "./member-details/state/member-details.model";
import { IMemberSearchState } from "./member-search/state/member-search.model";

export const FEATURE_NAME = 'memberFeature';

export interface IMemberState {
  memberSearchState: IMemberSearchState;
  memberDetailsState: IMemberDetailsState;
}

